import React from 'react'

import { Typography } from 'components/lib'

import Style from './NoSegmentContent.module.css'

export const NoSegmentContent = () => (
  <div className={Style['nosegment-container']}>
    <Typography
      tag="p"
      text="There is no segments added at the moment"
      color="gray600"
      size="m"
      weight="regular"
    />
  </div>
)
